import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";
import { isDeltashareAvailable } from "@lib/datashares/isDeltashareAvailable";

import { hasCurrentsPermissions } from "@services/useCurrentsPermissions";

const DatabricksDeltashareCreateForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatabricksDeltashareCreateForNro").then((module) => ({
    default: module.DatabricksDeltashareCreateForNro,
  }))
);

export const databricksDeltashareCreateNRO: NavigationRoutingObject = {
  Component: DatabricksDeltashareCreateForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("datashares-create-tab-databricks-heading", "Create Databricks Deltashare"),
  pageNameForTracking: () => "Create Databricks Deltashare",
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("datashares_integrations") &&
      isDeltashareAvailable(featureOn) &&
      hasCurrentsPermissions({ hasPermission }).canEditCurrents
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
